import { render } from "./AnnSetCopyModal.vue?vue&type=template&id=6b8ed6c2&scoped=true"
import script from "./AnnSetCopyModal.vue?vue&type=script&lang=js"
export * from "./AnnSetCopyModal.vue?vue&type=script&lang=js"

import "./AnnSetCopyModal.vue?vue&type=style&index=0&id=6b8ed6c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8ed6c2"]])

export default __exports__